import React, { useEffect } from "react";
import { Spin } from "antd";
import { resolveNewFrontendHref } from "../../../app/navigation/new-frontend-href";

const PORTAL_PATH = "/settlement/fuel-prices";

/**
 * 旧燃油价格管理和市场参考价地址一律进 Portal 的维护页。
 * 菜单已经指向新前端；收藏和手输的旧地址也走这里。
 */
export default function FuelPriceEntryRedirect() {
    useEffect(() => {
        window.location.replace(resolveNewFrontendHref(PORTAL_PATH));
    }, []);

    return (
        <div className="page-container">
            <div style={{ textAlign: "center", padding: 48 }}>
                <Spin />
                <div style={{ marginTop: 12 }}>正在打开燃油价格管理…</div>
            </div>
        </div>
    );
}
